import * as yup from "yup";
import { object, number } from 'yup'
import { date } from "./_types";

export default (currentProgram, programs) => {
  return object({
    code: number().required().oneOf(programs.map(p => p.code)),
    desiredCourse: yup.object({
      code: yup.string().required(),
      value: yup.object({
        location: yup.string().required(),
        startDate: yup.string().required()
      }).required(),
    }),
    remark: yup.object({
      text: currentProgram?.remarks?.length 
        ? yup.string().required('Muss ausgefüllt sein')
        : yup.string().nullable(),
    }).nullable(),
  }).required()
}
